import { render, staticRenderFns } from "./DashboardSistemas.vue?vue&type=template&id=589ec3bb"
import script from "./DashboardSistemas.vue?vue&type=script&lang=js"
export * from "./DashboardSistemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports